// ----------------------------------------------------------------------
// <copyright file="Izenda.DraggableRow.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------


!function () {
  var compose = require('recompose').compose;
  var draggable = require('share/components/hoc/Izenda.Draggable');
  var droppable = require('share/components/hoc/Izenda.Droppable');
  var TableRow = require('./Izenda.TableRow');
  var TypeComponent = 'row';

  var options = {
    beginDrag: function (props) {
      return {
        index: props.index,
        rowData: props.rowData,
        isDroppable: false
      };
    },
    canDrag: function (props, monitor) {
      var result = props.canDrag && props.canDrag(props.rowData);
      return result;
    }
  };

  var targetOptions = {
    drop: function (props, monitor, component) {
      if (monitor.didDrop()) {
        return {};
      }
      var dragIndex = monitor.getItem().index;
      var hoverIndex = props.index;
      if (monitor.getItem().isDroppable) {
        props.move(dragIndex, hoverIndex, monitor.getItem().rowData, props.rowData);
      } else {
        props.warning && props.warning();
      }
    },

    canDrop: function (props, monitor) {
      var result = props.canDrop && props.canDrop(props.rowData, monitor.getItem().rowData);
      var item = monitor.getItem();
      item.isDroppable = result;
      return true;
    }
  };

  var droppableRow = droppable(TypeComponent, targetOptions);
  var draggableRow = draggable(TypeComponent, options, false);

  module.exports = compose(draggableRow, droppableRow)(TableRow);
}();



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.DraggableRow.jsx